var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.opened
    ? _c("section", [
        _c("div", { staticClass: "modal", class: [_vm.active] }, [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm.modalHeader
                ? _c(
                    "header",
                    {
                      staticClass: "modal-header",
                      class: { hasborder: _vm.modalTopBorder }
                    },
                    [
                      _c("div", { staticClass: "modal-title" }, [
                        _c("h5", [_vm._v(_vm._s(_vm.$t(_vm.title)))])
                      ]),
                      _vm.btnClose
                        ? _c("button", {
                            staticClass: "btn-close",
                            on: {
                              click: function($event) {
                                return _vm.close()
                              }
                            }
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "description" },
                        [
                          _vm._t("subtitle", [
                            _vm._v(" " + _vm._s(_vm.subtitle) + " "),
                            _vm.subtitle2 ? _c("br") : _vm._e()
                          ]),
                          _vm._t("subtitle2", [
                            _vm._v(" " + _vm._s(_vm.subtitle2) + " "),
                            _vm.subtitle3 ? _c("br") : _vm._e()
                          ]),
                          _vm._t("subtitle3", [_vm._v(_vm._s(_vm.subtitle3))])
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e(),
              _vm.modalBody
                ? _c(
                    "div",
                    { staticClass: "modal-body" },
                    [_vm._t("content")],
                    2
                  )
                : _vm._e(),
              _vm.modalFooter
                ? _c(
                    "footer",
                    {
                      staticClass: "modal-footer",
                      class: {
                        hasborder: _vm.modalBottomBorder,
                        check: _vm.modalCheckBox
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "btn-area--bottom" },
                        [
                          _vm._t("footer", [
                            _vm.noNegativeButton
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn bottom negative",
                                    on: { click: _vm.cancelClick }
                                  },
                                  [_vm._v(_vm._s(_vm.$t(_vm.cancel)))]
                                )
                              : _vm._e(),
                            _c(
                              "button",
                              {
                                staticClass: "btn bottom positive",
                                on: { click: _vm.confirmClick }
                              },
                              [_vm._v(_vm._s(_vm.$t(_vm.confirm)))]
                            )
                          ])
                        ],
                        2
                      )
                    ]
                  )
                : _vm._e()
            ])
          ])
        ]),
        _vm.noDimClose
          ? _c("div", { staticClass: "modal-backdrop" })
          : _c("div", {
              staticClass: "modal-backdrop",
              on: {
                click: function($event) {
                  return _vm.close()
                }
              }
            })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }